import { ProjectPlan } from "../../enums/ProjectPlan";
import { IProject } from "../../interfaces/IProject";
import { IProjectKeyword } from "../../interfaces/IProjectKeyword";
import Calls from "../../utils/Calls";

export interface INewProject{
    name: string;
    domain: string;
    location: string;
    competitors: Array<string>;
    thumbImagePath?: string;
    googleToken?: string | null;
    collabimAuthKey?: string;
    projectPricePlan: ProjectPlan;
}

export const createProject = async (data: INewProject) : Promise<IProject> => {
    const commandUri = Calls.getApiUri(Calls.apiBaseUri+"project");
    let options = {
        name: data.name, 
        domain: data.domain,
        location: data.location,
        googleToken: data.googleToken,
        competitors: data.competitors,
        projectPricePlan: data.projectPricePlan,
        thumbImagePath: data.thumbImagePath
    }
    if(typeof data.googleToken == "string"){
        options.googleToken = data.googleToken;
    }
    return await Calls.call("POST", commandUri, options);
};

export const importKeywordsManual = async (projectId: string, keywordList: Array<string>) : Promise<Array<IProjectKeyword>> => {
    const commandUri = Calls.getApiUri(`${Calls.apiBaseUri}project/${projectId}/keywords/import/list`);
    return await Calls.call("POST", commandUri, keywordList)
}
export const importKeywordsCollabim = async (projectId: string, apiKey: string, collabimProjectId: number) : Promise<Array<IProjectKeyword>> => {
    const commandUri = Calls.getApiUri(`${Calls.apiBaseUri}project/${projectId}/keywords/import/collabim`);
    return await Calls.call("POST", commandUri, {
        "collabimApiKey": apiKey,
        "collabimProjectId": collabimProjectId
    })
}
export const importKeywordsFile = async (projectId: string, fileName: string) : Promise<Array<IProjectKeyword>> =>{
    const commandUri = Calls.getApiUri(`${Calls.apiBaseUri}project/${projectId}/keywords/import/file`);
    return await Calls.call("POST", commandUri, {name: fileName})
}
// export const importKeywordsFile = async (projectId:)